import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/** 예전 /cctv-popup/pool/... 경로 → /POOL002/grid 형식으로 이동 */
const CctvLegacyPopupRedirect: React.FC = () => {
  const { poolCode, mode } = useParams<{ poolCode: string; mode: string }>();
  const location = useLocation();
  if (!poolCode || !mode) {
    return <Navigate to="/central-control" replace />;
  }
  return (
    <Navigate
      to={`/${encodeURIComponent(poolCode)}/${mode}${location.search}`}
      replace
    />
  );
};

export default CctvLegacyPopupRedirect;
